import EditorInChief from "../components/EditorInChief/EditorInChief";

export default function EditorInChiefPage() {
  return <EditorInChief />;
}
